import React, { Component } from 'react';
import { DropdownButton, MenuItem }  from 'react-bootstrap';

// import Select from 'react-select'


class AccountForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
        accounts: [],
        currentAccount: 0,
    };

    let currentAccount = localStorage.getItem('currentAccount');
    if (currentAccount) {
        this.state.currentAccount = parseInt(currentAccount, 10);
    }    

    this.handleSubmit = this.handleSubmit.bind(this);
    this.setAccountID = this.setAccountID.bind(this);
  }

  componentDidMount() {

    let options = this.props.fetchOptions();

    fetch("/api/accounts", options)
    .then(res => res.json())
    .then(payload => {
        if (payload.message) { // If the token isn't valid...
            alert(payload.message);
        } else { // If it is...
            console.log("accounts payload: ", payload);

            // var accounts = payload.map((account) => { 
            //     return { value: account.id, label: account.name }
            // })

            console.log("Accounts: ", payload)
            this.setState({ accounts: payload })        

            console.log("Current", this.state.currentAccount);

            if (this.state.currentAccount === 0 && this.state.accounts.length > 0) {
                this.setAccountID(this.state.accounts[0].id);
            } else {
                this.setAccountID(this.state.currentAccount);
            }
        }
    }).catch(() => alert("An unknown error occured loading accounts."));
  }

  setAccountID(accountID) {
    let account = this.state.accounts.find(function(a) {
        return a.id === accountID;
    })
    console.log("setting account to", account);
    localStorage.setItem('currentAccount', accountID);
    this.props.onAccountChange(account);
    this.setState({currentAccount: accountID});

  }

  handleSubmit(event) {
    alert('Your favorite flavor is: ' + this.state.value);
    event.preventDefault();
  }

//   <Select options={this.state.accounts} />                                        


  render() {
    if (this.state.accounts.length === 0) {
      return null
    }
    if (this.state.accounts.length === 1) {
      return (<div>{this.state.accounts[0].name}</div>)
    }
    console.log("ACCOUNTS:", this.state.accounts)

    let currentID =this.state.currentAccount
    let current = this.state.accounts.find(function(a) {
      console.log("A: ", a)
      console.log("currentAccount: ", currentID)
      return a.id === currentID
    })

    if (current === undefined) {
      return null
    }

return (
<DropdownButton
      bsStyle="primary"
      title={current.name}
      key={this.state.currentAccount}
      id={`account-dropdown`}
      noCaret={true}
      onSelect={this.setAccountID}
    >
    {
        this.state.accounts.map((account) => 
          <MenuItem
            eventKey={account.id}
            active={account.id===currentID}>
              {account.name}
            </MenuItem>
        )
    }
    </DropdownButton>

    );
  }
}

export default AccountForm;


// WEBPACK FOOTER //
// ./src/Components/Ledger/AccountForm.js